import { putInitRecord, cleanStore } from '../../actions/record/recordActions';
import { fetchVinCheck } from '../../actions/vincheck/vincheckActions';

const mapDispatchToProps = (dispatch) => ({
  // fetchRecord: (recordId, customDataToAdd) => dispatch(fetchRecord(recordId, customDataToAdd)),
  putInitRecord: (record) => dispatch(putInitRecord(record)),
  fetchVinCheck: (recordId) => dispatch(fetchVinCheck(recordId)),
  cleanStore: (newRecords) => dispatch(cleanStore(newRecords)),
});

export default mapDispatchToProps;
